var _g, _g2, _g3, _polygon, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "367.7 -24.5 23 24.5",
    enableBackground: "new 367.7 -24.5 23 24.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -371.8,
    y: -345,
    width: 969.8,
    height: 713.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 511.5,
    y: 370.4,
    width: 75.1,
    height: 29.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -3.051758e-05)",
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 1710,
    height: 1276,
    xlinkHref: "Screen Shot 2014-08-07 at 1.16.05 PM.png",
    transform: "matrix(0.6175 0 0 0.6175 -345.4637 -358.1656)"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "381.7,-10.9 381.7,-19.7 379.2,-19.7 376.7,-19.7 376.7,-10.9 372.6,-10.9 379.2,-4.8 385.8,-10.9 "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropoff);
export default __webpack_public_path__ + "static/media/dropoff.55cce27f7c249325d71f965c7ceafef5.svg";
export { ForwardRef as ReactComponent };